module.exports = "Home - Chiclete\n<br />\nv-developer"